import Button from "../Button/Button";

interface PaymentButtonProps {
  sendPayment: () => void;
  inProcess: boolean;
}

const PaymentButton = ({
  sendPayment,
  inProcess = false,
}: PaymentButtonProps) => {
  return (
    <Button
      color="primary-filled"
      action={sendPayment}
      loading={inProcess}
      disable={inProcess}
    >
      <p>Realiza tu pedido y paga</p>
    </Button>
  );
};

export default PaymentButton;
